import React from 'react'

import { I18n } from '@front/volcanion'

import { TableHeader, TableRow, SearchFrame, SearchForm, SearchTable, FormContent } from '@front/squirtle'
import { Grid, Box } from '@mui/material'

import Form from './Form'
import Header from './Header'
import Row from './Row'

const VoucherList = () =>
  <Box sx={{ p: 2 }}>
    <Grid container justifyContent='center'>
      <Grid size={11}>
        <SearchFrame
          model_name={'voucher'}
          populate={['createdBy.info', 'companyservice.contract.company', 'schedule']}
          sort={['createdAt DESC']}
          createButtonProps={{ label: I18n.t('voucher.add') }}
        >
          <SearchForm submitOnMount>
            <FormContent><Form /></FormContent>
          </SearchForm>
          <SearchTable
            tableProps={{
              enablePagination: true,
              allowEditMode: false,
              allowRowGenerate: false
            }}
          >
            <TableHeader><Header /></TableHeader>
            <TableRow><Row /></TableRow>
          </SearchTable>
        </SearchFrame>
      </Grid>
    </Grid>
  </Box>

export default React.memo(VoucherList)
